export default param => param.split('/');
